//1.导入vue和router包
import Vue from 'vue'
import VueRouter from 'vue-router'

import home_page from '@/views/pages/homePage.vue'
import shortlistPage from '@/views/pages/shortlistPage.vue'
import applyList from '@/views/pages/applyList.vue'
import actInfoPage from '@/views/pages/actManage/actInfoPage.vue'
import actResultPage from '@/views/pages/actManage/actResultPage.vue'
import submitInfoPage from '@/views/pages/actManage/submitInfoPage.vue'

//2.调用Vue.use()函数，把 VueRouter 安装为 Vue 的插件
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'homePage',
        component: home_page
    },
    {
        path: '/shortlistPage',
        name: 'shortlistPage',
        component: shortlistPage
    },
    {
        path: '/applyList',
        name: 'applyList',
        component: applyList
    },
    {
        path: '/actInfoPage',
        name: 'actInfoPage',
        component: actInfoPage
    },
    {
        path: '/actResultPage',
        name: 'actResultPage',
        component: actResultPage
    },
    {
        path: '/submitInfoPage',
        name: 'submitInfoPage',
        component: submitInfoPage
    },
]

//3.创建路由的示例对象
const router = new VueRouter({
    // mode: 'hash',
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

//4.向外共享路由示例对象
export default router